import type { SeatmapSeat } from '@/types';

/** Convert client (mouse/touch) coordinates to canvas-local coordinates. */
export function canvasCoords(canvas: HTMLCanvasElement, clientX: number, clientY: number): { x: number; y: number } {
  const rect = canvas.getBoundingClientRect();
  const dpr = window.devicePixelRatio || 1;
  const scaleX = (canvas.width / dpr) / rect.width;
  const scaleY = (canvas.height / dpr) / rect.height;
  return {
    x: (clientX - rect.left) * scaleX,
    y: (clientY - rect.top) * scaleY,
  };
}

/** Draw a seat image centered on the seat's position, scaled inversely by bake factor. */
export function drawSeatImage(ctx: CanvasRenderingContext2D, seat: SeatmapSeat, image: HTMLImageElement, bake: number): void {
  const w = (image.naturalWidth || image.width) / bake;
  const h = (image.naturalHeight || image.height) / bake;
  ctx.save();
  ctx.translate(seat.x, seat.y);
  ctx.drawImage(image, -w / 2, -h / 2, w, h);
  ctx.restore();
}

/** Compute the distance between two touch points. */
export function getTouchDist(touches: TouchList): number {
  const dx = touches[1].clientX - touches[0].clientX;
  const dy = touches[1].clientY - touches[0].clientY;
  return Math.sqrt(dx * dx + dy * dy);
}
